module.exports = __webpack_public_path__ + "img/logoEthixBase.82475cda.png";